import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { PaymentStates } from 'core/enums/payment-states';
import { PaymentFailure } from './payment-states/payment-failure';
import { PaymentPending } from './payment-states/payment-pending';
import { PaymentRefresh } from './payment-states/payment-refresh';
import { PaymentSuccess } from './payment-states/payment-success';
import { Button } from '../../buttons/button';
import { PopupStore } from '../popup.store';

export const PaymentNoticePopup = observer<{ popupStore: PopupStore; styles: any }>(({ popupStore, styles }) => {
  const { t } = useTranslation();
  return popupStore.paymentInProgress ? (
    {
      [PaymentStates.Pending]: <PaymentPending popupStore={popupStore} styles={styles} />,
      [PaymentStates.Failure]: <PaymentFailure popupStore={popupStore} styles={styles} />,
      [PaymentStates.Refresh]: <PaymentRefresh popupStore={popupStore} styles={styles} />,
      [PaymentStates.Success]: <PaymentSuccess popupStore={popupStore} styles={styles} />,
    }[popupStore.paymentState]
  ) : (
    <>
      <div className="row">
        <div className={`text-regular ${styles.paymentNoticeContent}`}>
          <p className={styles.mainText}>{t('payments.paymentNoticeBodyText')}</p>
          <p>{t('payments.paymentNoticeBodyNote')}</p>
        </div>
      </div>

      <div className={`row ${styles.popupActionButtons} ${styles.continueButton}`}>
        {popupStore.config?.actionButton && (
          <Button
            classes={[styles.popupButton]}
            meta={popupStore.config.actionButton}
            onClick={() => popupStore.onAction()}
          ></Button>
        )}
      </div>

      <div className={styles.note}>
        <div className="text-caption-title-small">
          <span className={styles.textBold}>{t('payments.paymentNoticeFooterHeading')}</span>
          <p>{t('payments.paymentNoticeFooterBodyText')}</p>
        </div>
      </div>
    </>
  );
});